document.addEventListener("DOMContentLoaded", function () {
  let checkMenu = document.querySelector('.wishlistNavappend');
  let checkMobilemenu = document.querySelector('.wishlistMobileAppend');
  setTimeout(function(){
      let menuNav = document.querySelector(".tmenu_nav");
      if(checkMenu && menuNav){
        menuNav.appendChild(checkMenu);
      }
  }, 100);

  setTimeout(function(){
  let mobileNavAppend = document.querySelector('.mobile-nav.tmenu_app');
    if(mobileNavAppend && checkMobilemenu){
      mobileNavAppend.appendChild(checkMobilemenu);
    }
  }, 500);

    let loginMenu = document.querySelector('.login-menu--dropdown');
  let menuDetails = document.querySelector('.account-menu.dropdown__nav');
  let bodyElement = document.body;

  if (loginMenu) {
    /* === CUENTA-MOVIL-NAVEGAR-SIN-MENU ===
       En movil, tocar "Mi cuenta" debe NAVEGAR a la cuenta, no desplegar el
       panel de 6 enlaces. El menu se queda solo en escritorio.

       Por que se abria en el iPhone: iOS Safari SINTETIZA un mouseenter en el
       primer toque. No es un mecanismo tactil deliberado, es un efecto
       colateral del navegador; el toque se consumia como "hover" y el
       <a href="{{ routes.account_url }}"> nunca navegaba.

       Por que la guarda va aqui y NO en CSS: estos handlers fijan
       opacity/visibility INLINE, asi que taparlo desde CSS seria una guerra de
       especificidad y el panel seguiria existiendo, invisible pero presente.
       Y sobre todo: has-dropdown-menu enciende un velo a pantalla completa
       (.has-dropdown-menu header ~ .fixed-overlay -> pointer-events:auto, en
       assets/theme.css). Ese velo es lo que realmente captura el toque, asi
       que ocultar el panel por CSS no habria arreglado nada.

       1023.98px es el breakpoint movil real del tema (el mismo de
       PIEZA-ABBR-MOBILE y el que usaba CUENTA-DROPDOWN-MOBILE-POS en
       custom.css, bloque retirado en este mismo cambio por quedar muerto).

       .matches se lee DENTRO de cada handler, no una sola vez al cargar: el
       MediaQueryList es vivo, asi que rotar el telefono o redimensionar la
       ventana cambia el comportamiento sin recargar.

       El listener 'change' NO es opcional. La guarda cubre mouseenter Y
       mouseleave, y precisamente por eso hace falta: si el panel esta abierto
       en escritorio y el viewport cruza a movil, el mouseleave que lo habria
       cerrado queda guardado, y has-dropdown-menu se quedaria puesto con el
       velo encendido -- justo el estado residual que se quiere evitar. Cerrar
       al cruzar el umbral lo cubre.

       Escritorio (>=1024px) queda con el comportamiento identico al de antes.
       REVERTIR: restaurar los dos addEventListener sin guarda y borrar
       accountDropdownMobile / closeAccountDropdown.
       ===================================================================== */
    const accountDropdownMobile = window.matchMedia('(max-width: 1023.98px)');

    const closeAccountDropdown = function () {
      bodyElement.classList.remove('has-dropdown-menu');
      if (menuDetails) {
        menuDetails.style.opacity = '0';
        menuDetails.style.visibility = 'hidden';
      }
    };

    loginMenu.addEventListener('mouseenter', function () {
      if (accountDropdownMobile.matches) return;
      if (bodyElement.classList.contains('customer--active')) {
        bodyElement.classList.add('has-dropdown-menu');
        menuDetails.style.opacity = '1';
        menuDetails.style.visibility = 'visible';
      }
    });

    loginMenu.addEventListener('mouseleave', function () {
      if (accountDropdownMobile.matches) return;
      if (bodyElement.classList.contains('customer--active')) {
        closeAccountDropdown();
      }
    });

    accountDropdownMobile.addEventListener('change', function (event) {
      if (event.matches) {
        closeAccountDropdown();
      }
    });
  }

  // product page table
  document.querySelectorAll('.product-template .rte table').forEach(table => {
    var wrapWith = document.createElement('div');
    wrapWith.classList.add('table-wrapper');
    table.parentNode.insertBefore(wrapWith, table);
    wrapWith.appendChild(table);
  });

  // let productMeta = document.querySelector(".product__info-wrapper");
  // if (productMeta){
  //   let salesFormat = productMeta.querySelector(".sales-format-text");
  //   let salesFormatpz = salesFormat.querySelector(".sales-formatText");
  //   let salesFormatDiv = document.querySelector(".product-variant-sales-format");

  //   if (!salesFormatDiv) return;
    
  //   document.addEventListener('click', function(e) {
  //     console.log("click");
  //     if (e.target.closest('.product__info-wrapper.swatch-view-item .star-set-image')) {
  //       let qtyInput = productMeta.querySelector(".js-qty__num");
  //       let qtyStep = qtyInput.getAttribute("step");
  //       console.log(qtyStep);            
  //       salesFormatpz.innerText = qtyStep;
  //     }
  //   });
  // }
  
  /* Q2 — toast de copia SKU en pagina de producto: mismo estilo que Y4 en cards.
     COPIAR-VARIANTE-02: recibe el mensaje; role=status para que el lector de
     pantalla lo anuncie. Solo se llama DESPUES de saber si se copio. */
  function skuFeedbackProduct(btn, mensaje) {
    var existing = document.querySelector('.sku-copied-toast');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    var toast = document.createElement('span');
    toast.className = 'sku-copied-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = mensaje || 'Copiado';
    document.body.appendChild(toast);
    if (btn && typeof btn.getBoundingClientRect === 'function') {
      var rect = btn.getBoundingClientRect();
      var th = toast.offsetHeight || 28;
      toast.style.left = Math.round(rect.left + rect.width / 2) + 'px';
      toast.style.top  = Math.max(6, Math.round(rect.top - th - 8)) + 'px';
    } else {
      toast.style.bottom = '90px';
      toast.style.left   = '50%';
    }
    setTimeout(function () {
      toast.classList.add('sku-copied-toast--out');
      setTimeout(function () {
        if (toast.parentNode) { toast.parentNode.removeChild(toast); }
      }, 350);
    }, 1700);
  }

  // prodcut sku copy — delegado en document; fallback execCommand (Q2-D).
  // COPIAR-VARIANTE-02: UNICA forma de copiar de la ficha (SKU y nombre de la
  // variante de Swatch King). «Copiado» solo si de verdad se copio; si no,
  // «No se pudo copiar». Antes el aviso salia al clic aunque fallara.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.copy-text button') : null;
    if (!btn) return;
    var copyBox = btn.closest ? btn.closest('.copy-text') : null;
    if (!copyBox) return;
    var textSpan = copyBox.querySelector('.text');
    if (!textSpan) return;
    var textToCopy = textSpan.innerText.trim();
    if (!textToCopy) return;
    if (btn.closest('label')) { e.preventDefault(); } /* boton dentro del label de Swatch King: no marcar su casilla */

    var conAviso = !copyBox.classList.contains('product-card-v2__sku');
    function avisar(ok) {
      if (conAviso) { skuFeedbackProduct(btn, ok ? 'Copiado' : 'No se pudo copiar'); }
    }

    /* Copia: execCommand devuelve false si el navegador la bloquea */
    function copiarConFallback() {
      var ta = document.createElement('textarea');
      ta.value = textToCopy;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;opacity:0;top:-9999px;left:-9999px;';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (ex) { ok = false; }
      document.body.removeChild(ta);
      avisar(ok);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(function () { avisar(true); }, copiarConFallback);
    } else {
      copiarConFallback();
    }
  });

  /* COPIAR-VARIANTE-02 — boton de copiar en la linea «<rotulo>: <nombre>» que
     pinta Swatch King en los grupos de producto (span.swatch-option-name con
     id="group…"), sea cual sea el rotulo. Este codigo SOLO coloca el boton
     (mismo marcado que el SKU: .copy-text > .text + button); copiar lo hace el
     manejador de arriba. Se re-coloca si la app repinta la linea. */
  var ICONO_COPIAR = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"></path></svg>';
  function colocarCopiaVariante() {
    document.querySelectorAll('.swatch-option-name[id^="group"]').forEach(function (rotulo) {
      if (!rotulo.closest('.product__info-container')) return; /* solo la ficha, no tarjetas de otros productos */
      var linea = rotulo.parentNode && rotulo.parentNode.querySelector('.swatch-variant-name');
      if (!linea) return;
      var caja = linea.querySelector('.maha-copia-variante');
      /* nombre = texto suelto de la linea (sin el «:» de .swatch-split-symbol) */
      var nombre = '';
      linea.childNodes.forEach(function (n) { if (n.nodeType === 3) nombre += n.nodeValue; });
      nombre = nombre.replace(/\s+/g, ' ').trim();
      if (caja) {
        if (!nombre) return; /* ya colocado y la app no metio texto nuevo */
        caja.parentNode.removeChild(caja); /* la app escribio otro nombre: rehacer */
      }
      if (!nombre) return;
      var primero = true; /* deja un espacio tras los dos puntos, como lo pinta la app */
      linea.childNodes.forEach(function (n) { if (n.nodeType === 3) { n.nodeValue = primero ? ' ' : ''; primero = false; } });
      caja = document.createElement('span');
      caja.className = 'copy-text maha-copia-variante';
      var t = document.createElement('span');
      t.className = 'text';
      t.textContent = nombre;
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Copiar nombre de la variante: ' + nombre);
      b.innerHTML = ICONO_COPIAR;
      caja.appendChild(t);
      caja.appendChild(b);
      linea.appendChild(caja);
    });
  }
  if (document.querySelector('.product__info-container')) {
    var copiaVariantePendiente = false;
    new MutationObserver(function () {
      if (copiaVariantePendiente) return;
      copiaVariantePendiente = true;
      requestAnimationFrame(function () { copiaVariantePendiente = false; colocarCopiaVariante(); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    colocarCopiaVariante();
  }

  function updateQuantityFields(targetElement, minQty, stepQty) {
    let qtyInput = targetElement.querySelector(".product__quantity .js-qty__num");
    let salesFormatpz = targetElement.querySelector(".sales-formatText");
    if (!minQty || !stepQty || !qtyInput || !salesFormatpz) return;
    qtyInput.setAttribute("min", minQty);
    qtyInput.setAttribute("step", stepQty);
    qtyInput.value = minQty;
    salesFormatpz.innerText = stepQty;
  }

  if (window.location.href.indexOf("/products/") === -1) {
    document.addEventListener("vsk:product:changed", function(response) {
      let targetElement = response.target;
      if(targetElement){
        let productHandle = targetElement.getAttribute('swatch-generated');
        wishlistElement = targetElement.querySelector('wishlist-king');
        setTimeout(function() {
        let productTitle = targetElement.querySelector('.product-card__title .reversed-link').innerHTML;
          if(productTitle){
            wishlistElement.setAttribute('data-selected-product-title', productTitle);
          }        
          if(productHandle){
            wishlistElement.setAttribute('data-product-handle', productHandle);
          }
        }, 100);
        new Wishlist('', wishlistElement);
        let modleHide = wishlistElement.querySelector('.show_list');
        if(modleHide){
          modleHide.classList.remove('show_list');
        }
        fetch(`/products/${productHandle}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const element = doc.querySelector('.pdpVariant-json');
          let jsonData = JSON.parse(element.textContent.trim());
          let minQty = jsonData[0].metamin_value;
          let stepQty = jsonData[0].metastep_value;
          let VariantId = jsonData[0].id;
          // updateQuantityFields(targetElement, minQty, stepQty);
        });

      }
    });

    document.addEventListener("vsk:variant:changed", function(response) {
      let variantId = response.detail.variant;
      let targetElement = response.target;
      let variantinformation = response.detail.variantInformation;
      let jsonObject = JSON.parse(variantinformation);
      let variantTitle = jsonObject.title;
      let variantSelect = targetElement.querySelector("select.product-single__variants");
      let variantInput = targetElement.querySelector(".product-variant-id");
      // quantity update
      if (variantSelect) {
        [...variantSelect.options].forEach((opt) => {
          if (opt.value == variantId) {
            opt.selected = true;
            variantSelect.dispatchEvent(new Event("change")); 
            let selectedOpt = variantSelect.options[variantSelect.selectedIndex];
            let minQty = selectedOpt.getAttribute("min") || 1;
            let stepQty = selectedOpt.getAttribute("step") || 1;
            // updateQuantityFields(targetElement, minQty, stepQty);
          }
        });
      }

      // Wishlist update
      
      if (variantInput){
        if(targetElement){
          wishlistElement = targetElement.querySelector('wishlist-king');
          if(wishlistElement){
            wishlistElement.setAttribute('data-selected-variant-id', variantId);
            wishlistElement.setAttribute('data-selected-variant-title', variantTitle);
            // new Wishlist('', wishlistElement);
            let modleHide = wishlistElement.querySelector('.show_list');
            if (modleHide) {
                modleHide.classList.remove('show_list');
            }
          }
        }
      }
    });
  }




// Variant change image js start
// function variantImageDisplay() {
//   let productCards = document.querySelectorAll('.product-card');
//   productCards.forEach((card) => {
//     let swatches = card.querySelectorAll('.swatch-view-image .star-set-image');
//     let gridImage = card.querySelector('.product-card__image-wrapper .product-card__image img');
//     if (!swatches.length || !gridImage) return;
//     swatches.forEach((item) => {
//       const getBgUrl = (el) => {
//         let bg = window.getComputedStyle(el).backgroundImage;
//         let url = bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
//         url = url.replace(/&width=\d+&height=\d+&crop=center/g, "");
//         return url;
//       };
//       if (item.dataset.evAdded) return;
//       item.dataset.evAdded = "true";
//       item.addEventListener("mouseenter", () => {
//         let url = getBgUrl(item);
//         gridImage.src = url;
//         gridImage.srcset = url;  
//       });
//       item.addEventListener("click", () => {
//         let url = getBgUrl(item);
//         gridImage.src = url;
//         gridImage.srcset = url;  
//       });
//     });
//   });
// }
// const observer = new MutationObserver(() => {
//   variantImageDisplay();
// });
// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
// });
// variantImageDisplay();
// Variant change image js end

});